import { FC } from "react";

import Points from "web/Layout/Common/Points";
import Price from "web/Layout/Common/Price";
import __ from "web/Layout/Translations";

import { IParsedOrder } from "web/types/Order";
import { IPaymentMethodItem } from "web/types/Payment";
import { MBProductType } from "web/types/Product";

import classes from "./paymentSources.scss";
import useSources from "./useSources";

interface ISuccessProductPaymentSourcesProps {
  className: string;
  item: IParsedOrder<MBProductType>["items"][number];
}

const SuccessProductPaymentSources: FC<ISuccessProductPaymentSourcesProps> = ({
  className,
  item,
}) => {
  const sources = useSources(item?.payment_method as IPaymentMethodItem[]);
  const pointsSources = sources.filter(({ type }) => type === "BANK_OF_POINTS");
  const paymentSources = sources.filter(
    ({ type }) => type !== "BANK_OF_POINTS"
  );
  const showDivider = pointsSources.length > 0 && paymentSources.length > 0;

  const renderSourceItem = ({
    name,
    id,
    type,
    value,
    code,
  }: (typeof sources)[number]) => {
    const isPrice = type !== "BANK_OF_POINTS";
    const parsedName = typeof name !== "string" ? name?.props.children : name;

    return (
      <li
        className={classes.item}
        key={name as string}
        data-t1="financing_sources_item"
        data-t2={id === "OWN_PAYMENT" ? "own_payment" : code || parsedName}
      >
        <span
          className={classes.name}
          data-t1="payment_sources_title"
          data-t2={parsedName}
        >
          {name}
        </span>
        {isPrice ? (
          <Price
            className={classes.value}
            value={value}
            currency={__("zł")}
            dataT1="payment_sources_price"
          />
        ) : (
          <Points
            className={classes.value}
            points={-value}
            dataT1="payment_sources_points"
          />
        )}
      </li>
    );
  };

  return (
    <div className={className}>
      <strong className={classes.title}>{__("Finansowanie")}</strong>
      {pointsSources.length > 0 && (
        <ul className={classes.list}>{pointsSources.map(renderSourceItem)}</ul>
      )}
      {showDivider && <hr className={classes.divider} />}
      {paymentSources.length > 0 && (
        <ul className={classes.list}>{paymentSources.map(renderSourceItem)}</ul>
      )}
    </div>
  );
};

export default SuccessProductPaymentSources;
